import { useQuery } from '@tanstack/react-query'

import { POSTHOG_FEATURE_FLAGS, useAuthState, usePostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks'
import {
  calculateRetryDelay,
  shouldRetryQuery
} from '@percent/partner-dashboard/common/hooks/useInfiniteQuery/useInfiniteQuery'
import { PartnerScopes } from '@percent/partner-dashboard/constants/scopes'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export function useExpandTimeLogRewards() {
  const { partner } = useAuthState()
  const { gamificationService } = useServices()
  const rewardsVisible = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.PD_VOLUNTEERING_REWARDS_VISIBILITY)
  const hasGamificationScope = !!partner?.scopes?.some(
    ({ scopeName, deletedAt }) => !deletedAt && scopeName === PartnerScopes.Gamification
  )

  const { data, isLoading } = useQuery({
    queryKey: ['getRewardRulesConfiguration'],
    queryFn: async () => (await gamificationService.getRewardRulesConfiguration()).data.data,
    enabled: rewardsVisible && hasGamificationScope,
    staleTime: 1000 * 60,
    retry: (failureCount, error) => shouldRetryQuery(failureCount, error),
    retryDelay: attemptIndex => calculateRetryDelay(attemptIndex)
  })

  return {
    isLoading,
    expandRewards: data?.status === 'configured' && data.configuration.rewardBehaviour === 'auto_donation'
  }
}
